import stu from "../../../images/stu.svg";
import { Link } from "react-router-dom";
import Card from "../../Cards/Card";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";

interface StatisticsProps {}

const Statistics: React.FC<StatisticsProps> = () => {
  return (
    <>
      <Row>
        <Col lg={6} md={6} className="flex justify-between ">
          <Title title="الاحصائيات" className="!text-center" />
          {/* <img src={logo} /> */}
        </Col>
      </Row>
      <Row justify={"center"}>
        <Col md={5} sm={10} lg={3} className="lg:mx-5  ">
          <Link to="/registered_students">
            <Card title={"عدد الطلاب المسجلين"} sum={300} image={stu} />
          </Link>
        </Col>

        <Col md={5} sm={10} lg={3} className="lg:mx-5 ">
          <Card title={"عدد الطلاب المتخرجين"} sum={300} image={stu} />
        </Col>

        <Col md={5} sm={10} lg={3} className="lg:mx-5 ">
          <Card title={"عدد الطلاب المستنفذين"} sum={300} image={stu} />
        </Col>
        <Col md={5} sm={10} lg={3} className="lg:mx-5">
          <Card title={"عدد الطلاب المفصولين"} sum={300} image={stu} />
        </Col>
        <Col md={6} sm={10} lg={3} className="lg:mx-5 max-lg:mx-auto">
          <Card title={" عدد الطلاب غير المستنفذين"} sum={300} image={stu} />
        </Col>
        <Col sm={10} lg={3} className="lg:mx-5"></Col>
      </Row>
    </>
  );
};

export default Statistics;
